<template>
   <div class="rounded-small my-2 size-10 overflow-hidden">
      <Image
         :src="params.url"
         class="size-full object-cover"
         :class="{
            '!object-contain': params.contain,
         }"
      />
   </div>
</template>

<script lang="ts" setup>
import type { GridCellProps, ImageCellParams } from '~/composables/grid/cell-params'

defineProps<GridCellProps<ImageCellParams>>()
</script>
